<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useI18n } from 'vue-i18n';
import SectionHeader from '@/components/SectionHeader.vue';
import { getCustomIcon } from '@/common/custom-icons.ts';
import type { GetProjectDetailsProjectResponse } from '@/api';

defineProps<{
  project: GetProjectDetailsProjectResponse;
}>();

const { t } = useI18n();
</script>

<template>
  <section v-if="project.tags.length > 0">
    <SectionHeader>{{ t('views.project.characteristics.header') }}</SectionHeader>
    <div>
      <ul class="grid grid-cols-3 gap-4 text-sm/4 text-gray-700 md:text-base/5 lg:text-lg/6">
        <li v-for="(tag, index) in project.tags" :key="index">
          <span class="mr-2 inline-flex h-4 w-4 items-center md:h-5 md:w-5 lg:h-6 lg:w-6">
            <FontAwesomeIcon :icon="getCustomIcon(tag.customIcon)" />
          </span>
          {{ tag.name }}
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="css" scoped></style>
